import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeader } from "@/components/kit";
import { Users, TrendingUp } from "lucide-react";
import { toast } from "sonner";

export default function Groups() {
  const [groups, setGroups] = useState([]);
  useEffect(() => { api.get("/groups").then((r) => setGroups(r.data)); }, []);
  return (
    <div className="mx-auto max-w-6xl px-4 py-8 lg:px-6">
      <SectionHeader overline="Join communities around favorite drink types" title="Interest groups" />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {groups.map((g) => (
          <div key={g.id} data-testid={`group-card-${g.id}`} className="card-lift group overflow-hidden rounded-xl border border-border bg-card">
            <Link to={`/groups/${g.id}`} className="relative block aspect-[16/9] overflow-hidden bg-muted">
              <img src={g.image} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              {g.trending && <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full glass px-2.5 py-1 text-xs font-semibold text-primary"><TrendingUp size={12} /> Trending</span>}
            </Link>
            <div className="p-4">
              <Link to={`/groups/${g.id}`}><h3 className="font-display text-2xl hover-underline">{g.name}</h3></Link>
              <p className="mt-1 flex items-center gap-1 text-sm text-muted-foreground"><Users size={13} /> {g.members.toLocaleString()} members</p>
              <p className="mt-2 line-clamp-2 text-sm text-muted-foreground">{g.about}</p>
              <button data-testid={`join-${g.id}`} onClick={() => toast.success(`Joined ${g.name}`)} className="mt-3 w-full rounded-full border border-border py-2 text-sm font-semibold hover:border-primary hover:text-primary">Join group</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
